import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from 'src/app/config/api-endpoints';
import { HttpService } from '../http-service/http.service';
import { ReturnDueCountResponseDto } from 'src/app/model/returns-due/return-due-response.dto';
import { ReturnDueCountRequestDto } from 'src/app/model/returns-due/return-due-request.dto';

@Injectable({ providedIn: 'root' })
export class HeaderDataService {
  private readonly returnsDueUrl = `${environment.apiBaseURL}${API_ENDPOINTS.header.GetReturnsDueCount}`;

  constructor(private http: HttpService) {}

  public loadReturnDue(
    request: ReturnDueCountRequestDto
  ): Observable<ReturnDueCountResponseDto> {
    return this.http.post(this.returnsDueUrl, request);
  }
}
